var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundUsage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 250,
    viewBox: "0 0 500 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2011_60873)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 250,
    fill: "#2D2F35"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M189 163.561V32L363 74.439V206L189 163.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M136 175.561V44L310 86.439V218L136 175.561Z",
    fill: "#5F6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 133.5C197 137.242 198.272 140.874 200.608 143.798C202.943 146.722 206.204 148.765 209.853 149.592C213.503 150.419 217.326 149.981 220.694 148.349C224.062 146.718 226.775 143.99 228.388 140.613C230.001 137.236 230.419 133.411 229.572 129.766C228.725 126.121 226.664 122.872 223.727 120.552C220.791 118.232 217.153 116.98 213.41 117C209.668 117.021 206.044 118.313 203.133 120.664L206.531 124.871C208.488 123.29 210.924 122.422 213.44 122.408C215.955 122.395 218.401 123.237 220.375 124.796C222.349 126.355 223.735 128.539 224.304 130.99C224.874 133.44 224.593 136.012 223.508 138.282C222.424 140.552 220.6 142.386 218.336 143.482C216.072 144.579 213.502 144.874 211.049 144.318C208.595 143.762 206.403 142.388 204.833 140.423C203.263 138.457 202.408 136.016 202.408 133.5H197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M217.832 149.668C221.499 148.686 224.723 146.486 226.975 143.43C229.228 140.373 230.374 136.642 230.226 132.849C230.078 129.055 228.645 125.424 226.162 122.553C223.679 119.681 220.293 117.738 216.561 117.044C212.828 116.35 208.971 116.945 205.621 118.732C202.272 120.519 199.629 123.392 198.127 126.878C196.625 130.365 196.353 134.259 197.356 137.92C198.358 141.582 200.576 144.794 203.644 147.03L206.875 142.595C204.812 141.093 203.321 138.933 202.647 136.472C201.973 134.01 202.156 131.393 203.166 129.049C204.175 126.705 205.952 124.774 208.204 123.572C210.455 122.371 213.049 121.971 215.558 122.438C218.067 122.904 220.343 124.21 222.012 126.141C223.681 128.071 224.644 130.512 224.744 133.062C224.843 135.612 224.073 138.121 222.559 140.175C221.045 142.23 218.878 143.709 216.412 144.369L217.832 149.668Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2011_60873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundUsage);
export default __webpack_public_path__ + "static/media/background-usage.dc6717fbe42fa6e81ee132e2b5638606.svg";
export { ForwardRef as ReactComponent };